import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";

const LanguageContext = createContext(null);
const STORAGE_KEY = "builders_binder_language";

const translations = {
  "Build Smarter": ["Construye de forma más inteligente", "更智慧地建造"],
  "Language": ["Idioma", "语言"],
  "Select language": ["Seleccionar idioma", "选择语言"],
  "English": ["Inglés", "英语"],
  "Spanish": ["Español", "西班牙语"],
  "Chinese": ["Chino", "中文"],
  "Dashboard": ["Panel", "仪表板"],
  "Permits": ["Permisos", "许可证"],
  "Inspections": ["Inspecciones", "检查"],
  "Calendar": ["Calendario", "日历"],
  "Add Job": ["Agregar obra", "添加项目"],
  "Alert Settings": ["Configuración de alertas", "提醒设置"],
  "Alert History": ["Historial de alertas", "提醒历史"],
  "Feedback": ["Comentarios", "反馈"],
  "Account": ["Cuenta", "账户"],
  "Admin Panel": ["Panel de administración", "管理面板"],
  "Admin": ["Administrador", "管理员"],
  "SIGNED IN": ["SESIÓN INICIADA", "已登录"],
  "Sign out": ["Cerrar sesión", "退出登录"],
  "Have feedback?": ["¿Tienes comentarios?", "有反馈吗？"],
  "Let us know here!": ["¡Cuéntanos aquí!", "请在这里告诉我们！"],
  "Dismiss feedback banner": ["Cerrar aviso de comentarios", "关闭反馈横幅"],
  "Features": ["Funciones", "功能"],
  "How it works": ["Cómo funciona", "使用方式"],
  "Pricing": ["Precios", "价格"],
  "Open Dashboard": ["Abrir panel", "打开仪表板"],
  "Sign in": ["Iniciar sesión", "登录"],
  "Sign up": ["Registrarse", "注册"],
  "Get started free": ["Comenzar gratis", "免费开始"],
  "BUILT FOR NYC CONTRACTORS": ["CREADO PARA CONTRATISTAS DE NYC", "专为纽约市承包商打造"],
  "Manage every DOB permit in one place.": ["Gestiona todos los permisos del DOB en un solo lugar.", "在一个平台管理所有 DOB 许可证。"],
  "Stop refreshing DOB NOW. Stop missing inspections. We will help you track every filing across every NYC job site with instant notifications the second anything changes.": ["Deja de actualizar DOB NOW y de perder inspecciones. Te ayudamos a seguir cada trámite de todas tus obras en NYC con avisos instantáneos cuando algo cambie.", "无需再反复刷新 DOB NOW，也不会错过检查。我们帮助你跟踪纽约市每个工地的所有申报，并在发生变化时立即通知。"],
  "Start free trial": ["Iniciar prueba gratis", "开始免费试用"],
  "DOB lookups skipped weekly": ["consultas al DOB evitadas por semana", "每周省去的 DOB 查询"],
  "dashboard load time": ["tiempo de carga del panel", "仪表板加载时间"],
  "permit status monitoring": ["monitoreo del estado de permisos", "许可证状态监控"],
  "missed inspections": ["inspecciones perdidas", "错过的检查"],
  "The Problem": ["El problema", "面临的问题"],
  "10 active jobs. 50 manual DOB NOW lookups a week.": ["10 obras activas. 50 consultas manuales a DOB NOW por semana.", "10 个在建项目，每周手动查询 DOB NOW 50 次。"],
  "You're logging in, searching permit numbers one by one, copy-pasting status changes into a spreadsheet. Inspections get missed. Denials blindside you. The city office doesn't pick up.": ["Inicias sesión, buscas permisos uno por uno y copias los cambios a una hoja de cálculo. Se pierden inspecciones, las denegaciones te toman por sorpresa y la oficina municipal no responde.", "你需要登录、逐个搜索许可证编号，再把状态变化复制到表格中。检查会被错过，拒批令人措手不及，市政府办公室也无人接听。"],
  "Every minute spent refreshing DOB NOW is a minute not spent in the field.": ["Cada minuto actualizando DOB NOW es un minuto menos en la obra.", "每一分钟用来刷新 DOB NOW，就少一分钟用于现场工作。"],
  "Manual lookups for every permit, every week": ["Consultas manuales de cada permiso, cada semana", "每周手动查询每张许可证"],
  "Missed inspection appointments cost real money": ["Las inspecciones perdidas cuestan dinero real", "错过检查预约会造成实际损失"],
  "Permit denials surprise you 3 days late": ["Las denegaciones te sorprenden 3 días tarde", "许可证被拒三天后才发现"],
  "No single view across all active jobs": ["Sin una vista única de todas las obras activas", "无法统一查看所有在建项目"],
  "Live alert": ["Alerta en vivo", "实时提醒"],
  "Pending": ["Pendiente", "待处理"],
  "Approved": ["Aprobado", "已批准"],
  "What you get": ["Lo que obtienes", "你将获得"],
  "Built for the way NYC contractors actually work.": ["Creado para la forma en que realmente trabajan los contratistas de NYC.", "专为纽约市承包商的实际工作方式而设计。"],
  "Real-time DOB permit tracking, inspection reminders, and instant alerts, all in one dashboard.": ["Seguimiento de permisos del DOB en tiempo real, recordatorios de inspección y alertas instantáneas, todo en un solo panel.", "实时跟踪 DOB 许可证、检查提醒和即时通知，全部集中在一个仪表板中。"],
  "Manage every permit on one screen": ["Gestiona todos los permisos en una pantalla", "在一个屏幕管理所有许可证"],
  "Monitor all your DOB filings across all your job sites in a single, sortable view, color-coded by status so you can scan it in seconds.": ["Supervisa todos tus trámites del DOB en una vista ordenable, con colores por estado para revisarlos en segundos.", "在一个可排序的视图中监控所有工地的 DOB 申报，并按状态配色，几秒即可浏览。"],
  "Real-time email alerts": ["Alertas por correo en tiempo real", "实时邮件提醒"],
  "The moment a permit gets approved, denied, or flagged as delayed, you get an email alert.": ["En cuanto un permiso se aprueba, deniega o marca como demorado, recibes un correo.", "许可证一旦获批、被拒或标记为延迟，你就会收到邮件提醒。"],
  "Inspection reminders": ["Recordatorios de inspección", "检查提醒"],
  "24h and 48h heads-ups on every scheduled inspection, with calendar and list views built for the field.": ["Avisos con 24 y 48 horas de anticipación para cada inspección, con vistas de calendario y lista.", "每次计划检查前 24 和 48 小时提醒，并提供适合现场使用的日历和列表视图。"],
  "Delay flagging": ["Marcado de demoras", "延迟标记"],
  "Find permits by address": ["Buscar permisos por dirección", "按地址查找许可证"],
  "DOB NOW synced": ["Sincronizado con DOB NOW", "与 DOB NOW 同步"],
  "Three steps. Less than two minutes to set up.": ["Tres pasos. Menos de dos minutos para configurarlo.", "三个步骤，不到两分钟即可设置。"],
  "Add a job": ["Agregar una obra", "添加项目"],
  "We monitor": ["Nosotros monitoreamos", "我们持续监控"],
  "You get alerted": ["Recibes una alerta", "你会收到提醒"],
  "Plans that pay for themselves in one saved inspection.": ["Planes que se pagan solos con una inspección salvada.", "只要避免错过一次检查，套餐就物有所值。"],
  "Start free or pick a plan. No credit card required for the free trial.": ["Comienza gratis o elige un plan. La prueba no requiere tarjeta.", "免费开始或选择套餐。免费试用无需信用卡。"],
  "Free Trial": ["Prueba gratis", "免费试用"],
  "Starter": ["Inicial", "入门版"],
  "Pro": ["Pro", "专业版"],
  "Agency": ["Agencia", "机构版"],
  "Most popular": ["Más popular", "最受欢迎"],
  "Try before you buy": ["Pruébalo antes de comprar", "购买前先试用"],
  "For small GCs": ["Para contratistas generales pequeños", "适合小型总承包商"],
  "High-volume tracking": ["Seguimiento de gran volumen", "大批量跟踪"],
  "No credit card required": ["No se requiere tarjeta", "无需信用卡"],
  "Email alerts": ["Alertas por correo", "邮件提醒"],
  "Unlimited permits": ["Permisos ilimitados", "无限许可证"],
  "Unlimited jobs & permits": ["Obras y permisos ilimitados", "项目和许可证不限量"],
  "Start free": ["Comenzar gratis", "免费开始"],
  "Choose Starter": ["Elegir Inicial", "选择入门版"],
  "Choose Pro": ["Elegir Pro", "选择专业版"],
  "Choose Agency": ["Elegir Agencia", "选择机构版"],
  "Compare plans side by side": ["Compara los planes", "并排比较套餐"],
  "Feature": ["Función", "功能"],
  "Jobs & Permits": ["Obras y permisos", "项目和许可证"],
  "Active jobs": ["Obras activas", "在建项目"],
  "Permits per job": ["Permisos por obra", "每个项目的许可证"],
  "Boroughs supported": ["Distritos disponibles", "支持的行政区"],
  "Alerts & Monitoring": ["Alertas y monitoreo", "提醒与监控"],
  "Polling frequency": ["Frecuencia de consulta", "查询频率"],
  "Support": ["Soporte", "支持"],
  "Email support": ["Soporte por correo", "邮件支持"],
  "Priority support": ["Soporte prioritario", "优先支持"],
  "All plans billed monthly. Cancel anytime. Payments secured by Paddle.": ["Todos los planes se facturan mensualmente. Cancela cuando quieras. Pagos protegidos por Paddle.", "所有套餐按月计费，可随时取消，付款由 Paddle 安全处理。"],
  "Choose your plan": ["Elige tu plan", "选择你的套餐"],
  "Frequently asked questions.": ["Preguntas frecuentes.", "常见问题。"],
  "Privacy": ["Privacidad", "隐私"],
  "Terms": ["Términos", "条款"],
  "Welcome back": ["Bienvenido de nuevo", "欢迎回来"],
  "Sign in to your dashboard.": ["Inicia sesión en tu panel.", "登录你的仪表板。"],
  "Email": ["Correo electrónico", "电子邮箱"],
  "Password": ["Contraseña", "密码"],
  "Remember this device": ["Recordar este dispositivo", "记住此设备"],
  "Forgot password?": ["¿Olvidaste tu contraseña?", "忘记密码？"],
  "Signing in…": ["Iniciando sesión…", "正在登录…"],
  "New here?": ["¿Eres nuevo?", "第一次来？"],
  "Create an account": ["Crear una cuenta", "创建账户"],
  "Two-factor authentication required": ["Se requiere autenticación de dos factores", "需要双重身份验证"],
  "2FA Code": ["Código 2FA", "双重验证码"],
  "Verify & Sign in": ["Verificar e iniciar sesión", "验证并登录"],
  "Verifying…": ["Verificando…", "正在验证…"],
  "Resend code": ["Reenviar código", "重新发送验证码"],
  "Back to login": ["Volver al inicio de sesión", "返回登录"],
  "Show password": ["Mostrar contraseña", "显示密码"],
  "Hide password": ["Ocultar contraseña", "隐藏密码"],
  "Account recovery": ["Recuperación de cuenta", "账户恢复"],
  "Check your inbox": ["Revisa tu bandeja de entrada", "请查看收件箱"],
  "Reset password": ["Restablecer contraseña", "重置密码"],
  "Create your account.": ["Crea tu cuenta.", "创建你的账户。"],
  "Full name": ["Nombre completo", "姓名"],
  "Confirm password": ["Confirmar contraseña", "确认密码"],
  "Operations Overview": ["Resumen de operaciones", "运营概览"],
  "Your full week — at a glance.": ["Toda tu semana, de un vistazo.", "一览本周全貌。"],
  "Active Jobs": ["Obras activas", "在建项目"],
  "Open Permits": ["Permisos abiertos", "未结许可证"],
  "Pending Review": ["Revisión pendiente", "待审核"],
  "Approved This Week": ["Aprobados esta semana", "本周已批准"],
  "Inspections (7d)": ["Inspecciones (7 días)", "检查（7天）"],
  "Plan Objections": ["Objeciones al plan", "方案异议"],
  "Open Violations": ["Infracciones abiertas", "未结违规"],
  "ECB Balances": ["Saldos ECB", "ECB 欠款"],
  "Flagged / Delayed": ["Marcados / demorados", "已标记/延迟"],
  "Free Trial Limits": ["Límites de la prueba", "免费试用限制"],
  "Plan Usage": ["Uso del plan", "套餐用量"],
  "Upgrade": ["Mejorar plan", "升级"],
  "Next Inspection": ["Próxima inspección", "下次检查"],
  "No jobs yet": ["Aún no hay obras", "还没有项目"],
  "Add your first job to start tracking permits and inspections.": ["Agrega tu primera obra para comenzar a seguir permisos e inspecciones.", "添加第一个项目，开始跟踪许可证和检查。"],
  "Add Your First Job": ["Agregar tu primera obra", "添加第一个项目"],
  "Global View": ["Vista global", "全局视图"],
  "All Permits": ["Todos los permisos", "所有许可证"],
  "Job": ["Obra", "项目"],
  "Address": ["Dirección", "地址"],
  "Type": ["Tipo", "类型"],
  "Status": ["Estado", "状态"],
  "Flag": ["Marca", "标记"],
  "Delayed": ["Demorado", "延迟"],
  "No permits match your filters.": ["Ningún permiso coincide con los filtros.", "没有符合筛选条件的许可证。"],
  "Field schedule": ["Agenda de campo", "现场日程"],
  "No inspections scheduled.": ["No hay inspecciones programadas.", "没有计划检查。"],
  "Schedule": ["Agenda", "日程"],
  "Permit issuance dates and scheduled inspections — click any day to see details.": ["Fechas de emisión e inspecciones programadas; haz clic en un día para ver los detalles.", "许可证签发日期和计划检查——点击任意日期查看详情。"],
  "Day Detail": ["Detalle del día", "当日详情"],
  "Permits Issued": ["Permisos emitidos", "已签发许可证"],
  "Notifications": ["Notificaciones", "通知"],
  "Choose which updates should send an email alert.": ["Elige qué actualizaciones deben enviar una alerta por correo.", "选择哪些更新需要发送邮件提醒。"],
  "Delivery Channels": ["Canales de entrega", "发送渠道"],
  "Activity": ["Actividad", "活动"],
  "Add a construction job": ["Agregar una obra de construcción", "添加建设项目"],
  "Find permits by": ["Buscar permisos por", "查找许可证方式"],
  "Permits found": ["Permisos encontrados", "找到的许可证"],
  "Attach permits": ["Adjuntar permisos", "关联许可证"],
  "Active permits": ["Permisos activos", "有效许可证"],
  "Active plan filings": ["Trámites de planos activos", "有效方案申报"],
  "Manual entries": ["Entradas manuales", "手动输入"],
  "Creating your job": ["Creando tu obra", "正在创建项目"],
  "Loading permit data": ["Cargando datos de permisos", "正在加载许可证数据"],
  "Use Refresh to try again.": ["Usa Actualizar para intentarlo de nuevo.", "请点击刷新重试。"],
  "Refresh": ["Actualizar", "刷新"],
  "Current DOB status": ["Estado actual del DOB", "当前 DOB 状态"],
  "Stop Work Order": ["Orden de paralización", "停工令"],
  "Violations": ["Infracciones", "违规"],
  "Contacts": ["Contactos", "联系人"],
  "History": ["Historial", "历史"],
  "All": ["Todos", "全部"],
  "Any date": ["Cualquier fecha", "任意日期"],
  "After date": ["Después de la fecha", "晚于日期"],
  "Before date": ["Antes de la fecha", "早于日期"],
  "Issued": ["Emitido", "已签发"],
  "Expires": ["Vence", "到期"],
  "Filed": ["Presentado", "已申报"],
  "Actions": ["Acciones", "操作"],
  "No activity yet.": ["Aún no hay actividad.", "暂无活动。"],
  "Current plan": ["Plan actual", "当前套餐"],
  "Change Password": ["Cambiar contraseña", "修改密码"],
  "Verification code": ["Código de verificación", "验证码"],
  "New password": ["Nueva contraseña", "新密码"],
  "Confirm new password": ["Confirmar nueva contraseña", "确认新密码"],
  "Passwords do not match.": ["Las contraseñas no coinciden.", "两次密码不一致。"],
  "Passwords match.": ["Las contraseñas coinciden.", "密码一致。"],
  "Email address": ["Correo electrónico", "电子邮箱地址"],
  "Current email": ["Correo actual", "当前邮箱"],
  "Phone number": ["Número de teléfono", "电话号码"],
  "Plan": ["Plan", "套餐"],
  "Jobs": ["Obras", "项目"],
  "Alerts": ["Alertas", "提醒"],
  "Manage your subscription": ["Gestiona tu suscripción", "管理订阅"],
  "Active plan": ["Plan activo", "当前套餐"],
  "Legal": ["Legal", "法律"],
  "Privacy Policy": ["Política de privacidad", "隐私政策"],
  "Terms of Service": ["Términos de servicio", "服务条款"],
  "Refund Policy": ["Política de reembolsos", "退款政策"],
  "Contact": ["Contacto", "联系我们"],
  "Payment successful": ["Pago exitoso", "付款成功"],
  "Payment in progress": ["Pago en curso", "付款处理中"],
  "Confirming your payment…": ["Confirmando tu pago…", "正在确认付款…"],
  "Close": ["Cerrar", "关闭"],
  "Previous slide": ["Diapositiva anterior", "上一张"],
  "Next slide": ["Diapositiva siguiente", "下一张"],
  "More": ["Más", "更多"],
};

const dynamicRules = [
  [/^Welcome back, (.+)\.$/, ["Bienvenido de nuevo, $1.", "欢迎回来，$1。"]],
  [/^(\d+) jobs?$/, ["$1 obra(s)", "$1 个项目"]],
  [/^(\d+) days?$/, ["$1 día(s)", "$1 天"]],
  [/^Up to (\d+) active jobs$/, ["Hasta $1 obras activas", "最多 $1 个在建项目"]],
  [/^Up to (\d+) permits per job$/, ["Hasta $1 permisos por obra", "每个项目最多 $1 张许可证"]],
];

function translateValue(value, language) {
  if (!value || language === "en") return value;
  const localeIndex = language === "es" ? 0 : 1;
  const leading = value.match(/^\s*/)?.[0] || "";
  const trailing = value.match(/\s*$/)?.[0] || "";
  const clean = value.trim();
  if (!clean) return value;
  if (translations[clean]) return `${leading}${translations[clean][localeIndex]}${trailing}`;
  for (const [pattern, localized] of dynamicRules) {
    if (pattern.test(clean)) {
      return `${leading}${clean.replace(pattern, localized[localeIndex])}${trailing}`;
    }
  }
  return value;
}

function shouldIgnore(node) {
  const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
  return !element || element.closest("[data-i18n-ignore], script, style, code, pre");
}

export function LanguageProvider({ children }) {
  const originalsRef = useRef(new WeakMap());
  const lastAppliedRef = useRef(new WeakMap());
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return ["en", "es", "zh"].includes(saved) ? saved : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, language); } catch {}
    document.documentElement.lang = language === "zh" ? "zh-Hans" : language;

    const originals = originalsRef.current;
    const lastApplied = lastAppliedRef.current;
    const attributeNames = ["placeholder", "title", "aria-label"];

    const applyText = (textNode) => {
      if (shouldIgnore(textNode)) return;
      const current = textNode.nodeValue;
      if (lastApplied.get(textNode) !== current) originals.set(textNode, current);
      const original = originals.get(textNode) ?? current;
      const translated = translateValue(original, language);
      if (translated !== current) textNode.nodeValue = translated;
      lastApplied.set(textNode, translated);
    };

    const applyElement = (element) => {
      if (shouldIgnore(element)) return;
      attributeNames.forEach((name) => {
        if (!element.hasAttribute?.(name)) return;
        const dataName = `i18nOriginal${name.replace(/-([a-z])/g, (_, c) => c.toUpperCase()).replace(/^./, c => c.toUpperCase())}`;
        const current = element.getAttribute(name);
        if (!element.dataset[dataName]) element.dataset[dataName] = current;
        element.setAttribute(name, translateValue(element.dataset[dataName], language));
      });
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) applyText(node);
    };

    applyElement(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") applyText(mutation.target);
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) applyText(node);
          if (node.nodeType === Node.ELEMENT_NODE) applyElement(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside LanguageProvider");
  return context;
}
